// @flow

/**
 * Removes non non-numeric characters and cast to number
 * @param {string} str
 */
const removeNonNumericAndCastToNumber = (str: string) => {
  return Number(str.replace(/\D/g, ''));
};

export { removeNonNumericAndCastToNumber };
